import { uniqueId } from 'lodash';

import { ApplianceModel, ApplianceSource, ApplianceType } from '@common/models';
import { addMockImage } from '@common/utils';
import { createSelector } from '@reduxjs/toolkit';

// TODO: Consolidate with sinks implemention
type SelectorCallback<T> = (
    data: ApplianceModel[],
    productSource: ApplianceSource,
    applianceType?: ApplianceType,
    shouldAddProductSourceToFeatures?: boolean
) => T;

// TODO: Consolidate with sinks implemention
/**
 * Corrects a given productSourceValue case
 * @param originalProductSource
 * @param correctProductSource
 */
const fixProductSourceCase = (originalProductSource: string, correctProductSource: string) => {
    return originalProductSource
        ? originalProductSource.replace(new RegExp(correctProductSource, 'gi'), correctProductSource)
        : correctProductSource;
};

// TODO: Consolidate with sinks implemention
export const makeDishwashersSelector = () =>
    createSelector<
        [
            SelectorCallback<ApplianceModel[]>,
            SelectorCallback<ApplianceSource>,
            SelectorCallback<ApplianceType | undefined>,
            SelectorCallback<boolean | undefined>
        ],
        ApplianceModel[]
    >(
        [
            (data) => data,
            (_, productSource) => productSource,
            (_, __, applianceType) => applianceType,
            (_, __, ___, shouldAddProductSourceToFeatures) => shouldAddProductSourceToFeatures,
        ],
        (data, productSource, applianceType, shouldAddProductSourceToFeatures = false) => {
            return data
                ?.map((dishwasher) => ({
                    ...dishwasher,
                    uuid: dishwasher.uuid ?? uniqueId(),
                    productSource,
                    applianceType: dishwasher.applianceType ?? applianceType,
                    features: shouldAddProductSourceToFeatures
                        ? [
                              ...(dishwasher.features ?? []),
                              {
                                  name: 'productSource',
                                  description: 'Product Source',
                                  position: 12,
                                  value: dishwasher.productSource // TODO Should we just use the given parameter productSource and ignore what the API provides?
                                      ? fixProductSourceCase(dishwasher.productSource, ApplianceSource.PROGRAM) // fix the case on program products
                                      : productSource,
                              },
                          ]
                        : dishwasher.features ?? [], //TODO: dishwasher.features in data may actually be undefined despite current typing saying otherwise. Fixing types required
                }))
                ?.map(addMockImage);
        }
    );
